import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ticket"
export default class extends Controller {

  static targets = ['qty', 'received', 'remaining' , "modal" ]

  static values = {
    remaining_this_fest: Number,
    id: Number,
    type: String
    }

  connect() {
    console.log('ticket connected')
    }

  increase(){
    if (this.remainingTarget.innerHTML > 0) {
    this.qtyTarget.value++
    this.receivedTarget.innerHTML++
    this.remainingTarget.innerHTML--
    this.dispatch("increase")
    }

  }

  decrease(){
    if (this.qtyTarget.value > 0) {
      this.qtyTarget.value--
      this.receivedTarget.innerHTML--
      this.remainingTarget.innerHTML++
      this.dispatch("decrease")
    }
  }

  saveButton(){
    if (this.qtyTarget.value > 0){
      
    }
  }

}
